import { render, staticRenderFns } from "./TestPlanRecord.vue?vue&type=template&id=225aaf4b&scoped=true"
import script from "./TestPlanRecord.vue?vue&type=script&lang=js"
export * from "./TestPlanRecord.vue?vue&type=script&lang=js"
import style0 from "./TestPlanRecord.vue?vue&type=style&index=0&id=225aaf4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225aaf4b",
  null
  
)

export default component.exports